/*
 * MigrationExportPage.tsx (RSX)
 *
 * Copyright © 2026 RSX Technologies GmbH - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * This file and all it's contents are proprietary and confidential.
 *
 * @file MigrationExportPage.tsx
 * @copyright 2026 RSX Technologies GmbH. All rights reserved.
 * @section License
 */

import React, { useEffect } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { useDispatch, useSelector } from 'react-redux';
import {
  getMigrationExportSummaryAction,
  downloadMigrationExportAction,
  downloadMigrationDocumentsAction
} from '../../../Store/MigrationExport';
import MigrationExportSummary from './MigrationExportSummary';

/**
 * The migration export screen.
 *
 * One read and one action. The read is what makes the screen worth having: it says what the export
 * contains and what is still outstanding *before* a multi-hundred-megabyte download is taken, so
 * the answer to "is this store ready to be migrated" is on screen rather than something an operator
 * finds out on the other side.
 */
const MigrationExportPage = () => {
  const dispatch = useDispatch();
  const migrationExport = useSelector((state) => state.migrationExport);

  /// Hand the browser a fresh single-use ticket and let it stream the file to disk.
  const startDownload = (): void => {
    dispatch(downloadMigrationExportAction());
  };

  /// The same, for the invoice PDFs, which travel as a download of their own.
  const startDocumentsDownload = (): void => {
    dispatch(downloadMigrationDocumentsAction());
  };

  useEffect(() => {
    dispatch(getMigrationExportSummaryAction());
  }, []);

  return (
    <Row>
      <Col sm={12}>
        <MigrationExportSummary
          summary={migrationExport.summary}
          isLoading={migrationExport.isFetchingSummary}
          isPreparingDownload={migrationExport.isPreparingDownload}
          startDownload={startDownload}
          startDocumentsDownload={startDocumentsDownload}
        />
      </Col>
    </Row>
  );
};

export default MigrationExportPage;
